/* BUTTON IN THE NAVIGATION BAR */
import React from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { styled } from '../styled';
import { theme } from '../theme';

const ButtonSubmit = styled(Button)((buttonType) => ({
  textAlign: 'center',
  fontSize: 16,
  maxHeight: 30,
  minWidth: 200,
  maxWidth: 400,
  borderRadius: 20,
  color: '#4DAC27',
  borderColor: '#4DAC27',
  backgroundColor: '#FFF',
  boxShadow: ` 5px 5px 10px ${theme.colors.mainGreen.secondary} `,
  border: '1px solid',
  '& .MuiButton-label': {
    fontFamily: 'Montserrat, sans-serif !important',
    fontWeight: 'bold'
  },
  '&:hover': {
    backgroundColor: '#FFF'
  }
}));
const variants = {
  none: {},
  column: {
    marginTop: 8
  },
  row: {
    marginRight: '3%'
  },
  listButton: {
    minWidth: '100%'
  },
  standard: {
    backgroundColor: 'transparent !important',
    borderBottom: '5px solid #31ccad',
    borderTop: 0,
    borderLeft: 0,
    borderRight: 0,
    width: '50%',
    marginRight: 0
  },
  standardMax: {
    backgroundColor: 'white !important',
    border: '1px solid #4DAC27',
    width: '100%',
    minWidth: 300,
    minHeight: 50,
    marginRight: 0
  },
  standardOpposite: {
    backgroundColor: 'transparent !important',
    borderBottom: '5px solid #40173b',
    borderTop: 0,
    borderLeft: 0,
    borderRight: 0,
    width: '50%',
    marginRight: 0
  },
  tableAction: {
    minWidth: 'fit-content',
    backgroundColor: '#FFF !important',
    marginRight: 2,
    padding: '0 5px'
  }
};

const SpButton = ({ text, type, onClick, buttonType, variant, disabled, style }) => {
  return (
    <ButtonSubmit
      disabled={disabled}
      type={type}
      style={{
        ...style,
        ...variants[variant]
      }}
      onClick={onClick}
      color="primary"
      disableElevation
      labelstyle={{
        fontFamily: 'Montserrat, sans-serif !important'
      }}
    >
      {text}
    </ButtonSubmit>
  );
};

export default SpButton;
